import { Directive, TemplateRef, ViewContainerRef, Input } from '@angular/core';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';

import { AccountState, accountType, AccountType } from 'src/app/core';

@UntilDestroy()
@Directive({
  selector: '[appShowAccountTypes]',
})
export class ShowAccountTypesDirective {
  acctTypes: AccountType[];
  ngUnsubscribe: Subject<any> = new Subject();

  @Input() set appShowAccountTypes(acctTypes: AccountType[]) {
    this.acctTypes = acctTypes;
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private store: Store<AccountState>,
    private viewContainer: ViewContainerRef
  ) {}

  ngOnInit() {
    this.store
      .select(accountType)
      .pipe(untilDestroyed(this))
      .subscribe((accountType) => {
        // If acct type is found in list of allowed acct types
        if (this.acctTypes.indexOf(accountType) !== -1) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
          this.viewContainer.clear();
        }
      });
  }
}
